'use client';

import { useCallback, useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import useSearchParams from '@/hooks/useSearchParams';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const MIN_RANGE = 0;
const MAX_RANGE = 10000;

const PriceFilter = ({ isMobile }) => {
  const t = useTranslations('common');

  const locale = useLocale();
  const { getFilterObj, setFilterQueryHandler } = useSearchParams();

  const initialRange = getFilterObj?.price?.split(',').map(Number) || [
    getFilterObj?.minPrice || MIN_RANGE,
    getFilterObj?.maxPrice || MAX_RANGE,
  ];

  const [range, setRange] = useState(initialRange);

  const handleRangeChange = useCallback(
    (value) => {
      setRange(value);
    },
    [setRange]
  );

  const handleRangeChangeComplete = useCallback(
    (value) => {
      setFilterQueryHandler({
        minPrice: value[0],
        maxPrice: value[1],
        p: null,
      });
    },
    [setFilterQueryHandler]
  );

  return (
    <div className='rounded-lg border border-[#F6F6F7] px-5 py-3'>
      <h3
        className={`text-lg font-semibold ${isMobile && 'text-xs font-bold'}`}
      >
        {t('price_key')}
      </h3>

      <div className='flex flex-col items-center gap-3 pt-4.25 max-md:gap-1 md:pt-6'>
        <div className='relative mx-auto h-1 w-[93%] rounded-sm max-md:mb-0'>
          <Slider
            range
            min={MIN_RANGE}
            max={MAX_RANGE}
            reverse={locale === 'ar'}
            step={20}
            value={range}
            allowCross={false}
            onChange={handleRangeChange}
            onChangeComplete={handleRangeChangeComplete}
            styles={{
              track: { backgroundColor: 'var(--color-primary)' },
              handle: {
                backgroundColor: 'var(--color-primary)',
                border: 'none',
              },
              rail: { backgroundColor: '#ddd' },
              dot: { backgroundColor: 'var(--color-primary)' },
              thumb: {
                backgroundColor: 'var(--color-primary)',
                border: 'none',
              },
            }}
          />
        </div>
        <div className='text-primary flex items-center gap-1 text-lg max-md:text-xs'>
          <span className='flex flex-row-reverse items-center gap-1'>
            <CurrencyIcon className='size-3.5 max-md:size-3' />
            {range[0] || MIN_RANGE}
          </span>
          <span> - </span>
          <span className='flex flex-row-reverse items-center gap-1'>
            <CurrencyIcon className='size-3.5 max-md:size-3' />
            {range[1] || MAX_RANGE}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PriceFilter;
